import { Components, PaletteMode, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';

/**
 * Default MUI `Skeleton` styles. The pounceV2 `Skeleton` wrapper applies a custom gradient
 * in `sx` and still uses `theme.palette.tokens.background.skeleton` for `base` / `wave` colors
 * in that gradient — see `packages/pounceV2/src/components/Skeleton/Skeleton.tsx`.
 */
export const MuiSkeletonTheme = (mode: PaletteMode): Components<Theme>['MuiSkeleton'] => {
  const { tokens } = themePalette(mode);

  return {
    styleOverrides: {
      root: {
        backgroundColor: tokens.background.skeleton.base,
      },
    },
  };
};
